"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = default_1;
const Printable_1 = require("../../models/printables/Printable");
const either_1 = require("../../types/either");
function default_1(project, action) {
  const interiorPrintableGroupIndex = project.printableGroups.findIndex(p => p.type === 'interior');
  if (interiorPrintableGroupIndex < 0) {
    return (0, either_1.left)(new Error(`Could not find interior printable group for project ${project.id}`));
  }
  const printableIndex = project.printableGroups[interiorPrintableGroupIndex].printables.findIndex(p => p.id === action.printableId);
  if (printableIndex < 0) {
    return (0, either_1.left)(new Error(`Could not find printable for project ${project.id}`));
  }
  const newLayers = project.printableGroups[interiorPrintableGroupIndex].printables[printableIndex].layers.filter(l => !action.layersId.includes(l.id));
  const newPrintable = (0, Printable_1.updatePrintableVersion)(project.printableGroups[interiorPrintableGroupIndex].printables[printableIndex], action.timestamp);
  newPrintable.layers = newLayers;
  project.printableGroups[interiorPrintableGroupIndex].printables[printableIndex] = newPrintable;
  const updatedEntities = [project, newPrintable];
  return (0, either_1.right)({
    updatedProject: project,
    updatedEntities: updatedEntities
  });
}